// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TasksView-module__font-s-10___Nbzyq {
  font-size: 10px !important;
}

.TasksView-module__font-s-12___o07lQ {
  font-size: 12px !important;
}

.TasksView-module__font-s-13___N9UwD {
  font-size: 13px !important;
}

.TasksView-module__font-s-14___bURso {
  font-size: 14px !important;
}

.TasksView-module__font-s-15___YgjGn {
  font-size: 15px !important;
}

.TasksView-module__font-s-16___YTVv0 {
  font-size: 16px !important;
}

.TasksView-module__font-s-18___tb6XM {
  font-size: 18px !important;
}

.TasksView-module__font-s-20___YQEZP {
  font-size: 20px !important;
}

.TasksView-module__font-s-22___JXI4Z {
  font-size: 22px !important;
}

.TasksView-module__font-s-28___z8baj {
  font-size: 28px !important;
}

.TasksView-module__font-w-400___wRfUh {
  font-weight: 400 !important;
}

.TasksView-module__font-w-500___rUKBG {
  font-weight: 500 !important;
}

.TasksView-module__font-w-600___O84ZF {
  font-weight: 600 !important;
}

.TasksView-module__font-w-700___LFzI7 {
  font-weight: 700 !important;
}

.TasksView-module__p-5___rXO3x {
  padding: 5px !important;
}

.TasksView-module__p-12___BOCj2 {
  padding: 12px !important;
}

.TasksView-module__p-16___y4nfO {
  padding: 16px !important;
}

.TasksView-module__p-30___Cd5oP {
  padding: 30px !important;
}

.TasksView-module__p-b-0___Qdq4u {
  padding-bottom: 0 !important;
}

.TasksView-module__p-b-5___ILV_Z {
  padding-bottom: 5px !important;
}

.TasksView-module__p-b-10___q7yu8 {
  padding-bottom: 10px !important;
}

.TasksView-module__p-b-12___kOaoA {
  padding-bottom: 12px !important;
}

.TasksView-module__p-b-16___WClaZ {
  padding-bottom: 16px !important;
}

.TasksView-module__p-b-18___JaM5s {
  padding-bottom: 18px !important;
}

.TasksView-module__p-b-20___Dvsvf {
  padding-bottom: 20px !important;
}

.TasksView-module__p-b-25___WrFf_ {
  padding-bottom: 25px !important;
}

.TasksView-module__p-b-30___RvdKU {
  padding-bottom: 30px !important;
}

.TasksView-module__p-b-50____AVts {
  padding-bottom: 50px !important;
}

.TasksView-module__p-t-0___vnsVW {
  padding-top: 0 !important;
}

.TasksView-module__p-t-12___eCFU7 {
  padding-top: 12px !important;
}

.TasksView-module__p-t-16___BWyZX {
  padding-top: 16px !important;
}

.TasksView-module__p-t-18___VljHN {
  padding-top: 18px !important;
}

.TasksView-module__p-t-20___PPxQG {
  padding-top: 20px !important;
}

.TasksView-module__p-t-30___tZhWr {
  padding-top: 30px !important;
}

.TasksView-module__p-t-40___NnV0m {
  padding-top: 40px !important;
}

.TasksView-module__p-t-50___PRiHf {
  padding-top: 50px !important;
}

.TasksView-module__p-l-20___WZI2g {
  padding-left: 20px !important;
}

.TasksView-module__p-l-30___XhYqO {
  padding-left: 30px !important;
}

.TasksView-module__p-l-40___uE1Nw {
  padding-left: 40px !important;
}

.TasksView-module__p-r-16___Ll1Ba {
  padding-right: 16px !important;
}

.TasksView-module__p-r-20___AJaP4 {
  padding-right: 20px !important;
}

.TasksView-module__p-r-30___v9Kjn {
  padding-right: 30px !important;
}

.TasksView-module__p-r-50___KYYos {
  padding-right: 50px !important;
}

.TasksView-module__p-r-60___W1Nn6 {
  padding-right: 60px !important;
}

.TasksView-module__m-b-1___OQqye {
  margin-bottom: 1px !important;
}

.TasksView-module__m-b-2___NBCqA {
  margin-bottom: 2px !important;
}

.TasksView-module__m-b-6___lc6Ho {
  margin-bottom: 6px !important;
}

.TasksView-module__m-b-8___OougC {
  margin-bottom: 8px !important;
}

.TasksView-module__m-b-10___W90qg {
  margin-bottom: 10px !important;
}

.TasksView-module__m-b-14___H8aym {
  margin-bottom: 14px !important;
}

.TasksView-module__m-b-16____Dygj {
  margin-bottom: 16px !important;
}

.TasksView-module__m-b-20___uVJRn {
  margin-bottom: 20px !important;
}

.TasksView-module__m-b-22___Usixw {
  margin-bottom: 22px !important;
}

.TasksView-module__m-b-24___VbVGR {
  margin-bottom: 24px !important;
}

.TasksView-module__m-b-30___En97Q {
  margin-bottom: 30px !important;
}

.TasksView-module__m-b-32___cnJWX {
  margin-bottom: 32px !important;
}

.TasksView-module__m-b-40___TyPsN {
  margin-bottom: 40px !important;
}

.TasksView-module__m-t-2___Osm8j {
  margin-top: 2px !important;
}

.TasksView-module__m-t-3___K6cCK {
  margin-top: 3px !important;
}

.TasksView-module__m-t-4___W2eZs {
  margin-top: 4px !important;
}

.TasksView-module__m-t-5___KaUdW {
  margin-top: 5px !important;
}

.TasksView-module__m-t-8___jXqhe {
  margin-top: 8px !important;
}

.TasksView-module__m-t-10___Dt3yL {
  margin-top: 10px !important;
}

.TasksView-module__m-t-15___jGV1h {
  margin-top: 15px !important;
}

.TasksView-module__m-t-16___uZPMP {
  margin-top: 16px !important;
}

.TasksView-module__m-t-20___d57bl {
  margin-top: 20px !important;
}

.TasksView-module__m-t-22___mtbca {
  margin-top: 22px !important;
}

.TasksView-module__m-t-30___vB7A3 {
  margin-top: 30px !important;
}

.TasksView-module__m-t-32___tfo8o {
  margin-top: 32px !important;
}

.TasksView-module__m-l-auto___MRf2y {
  margin-left: auto !important;
}

.TasksView-module__m-l-4____3xdN {
  margin-left: 4px !important;
}

.TasksView-module__m-l-5___esotw {
  margin-left: 5px !important;
}

.TasksView-module__m-l-6___VYq79 {
  margin-left: 6px !important;
}

.TasksView-module__m-l-8___A6J_D {
  margin-left: 8px !important;
}

.TasksView-module__m-l-10___sEZsC {
  margin-left: 10px !important;
}

.TasksView-module__m-l-16___ROs8c {
  margin-left: 16px !important;
}

.TasksView-module__m-l-20___wjSfK {
  margin-left: 20px !important;
}

.TasksView-module__m-l-24___PPLdL {
  margin-left: 24px !important;
}

.TasksView-module__m-l-30___Eokx6 {
  margin-left: 30px !important;
}

.TasksView-module__m-l-35___ZcvH7 {
  margin-left: 35px !important;
}

.TasksView-module__m-l-40___iqRTw {
  margin-left: 40px !important;
}

.TasksView-module__m-r-8___Y_fhq {
  margin-right: 8px !important;
}

.TasksView-module__m-r-10___tBwsX {
  margin-right: 10px !important;
}

.TasksView-module__m-r-16___xQv53 {
  margin-right: 16px !important;
}

.TasksView-module__m-r-20____z6UP {
  margin-right: 20px !important;
}

.TasksView-module__m-r-24___wbTZg {
  margin-right: 24px !important;
}

.TasksView-module__m-r-30___kcORT {
  margin-right: 30px !important;
}

.TasksView-module__m-r-40___BQKIz {
  margin-right: 40px !important;
}

.TasksView-module__border-r-3___LahwX {
  border-radius: 3px !important;
}

.TasksView-module__border-r-4___Oq3db {
  border-radius: 4px !important;
}

.TasksView-module__border-r-6___o8yPN {
  border-radius: 6px !important;
}

.TasksView-module__border-r-10___eIOxE {
  border-radius: 10px !important;
}

.TasksView-module__border-r-12___x932X {
  border-radius: 12px !important;
}

.TasksView-module__border-r-16___DuWEA {
  border-radius: 16px !important;
}

.TasksView-module__border-r-50___Qx6Z4 {
  border-radius: 50% !important;
}

.TasksView-module__primary-border___niNYr {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.TasksView-module__primary-border-b___nfZ0B {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.TasksView-module__primary-border-t___JSVcm {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.TasksView-module__primary-border-l___i08aJ {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.TasksView-module__primary-border-r___bkMFY {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.TasksView-module__secondary-border____EXKg {
  border: 1px solid #637768;
}

.TasksView-module__secondary-border-b___nlW_F {
  border-bottom: 1px solid #637768;
}

.TasksView-module__secondary-border-t___FHWEg {
  border-top: 1px solid #637768;
}

.TasksView-module__secondary-border-l___DBEKi {
  border-left: 1px solid #637768;
}

.TasksView-module__secondary-border-r___uflmS {
  border-right: 1px solid #637768;
}

.TasksView-module__gap-0___kFaqY {
  gap: 0 !important;
}

.TasksView-module__gap-2___udmBt {
  gap: 2px !important;
}

.TasksView-module__gap-4___IydaM {
  gap: 4px !important;
}

.TasksView-module__gap-5___MDKR0 {
  gap: 5px !important;
}

.TasksView-module__gap-6___CzZn4 {
  gap: 6px !important;
}

.TasksView-module__gap-8___y_YEk {
  gap: 8px !important;
}

.TasksView-module__gap-10___JFR_C {
  gap: 10px !important;
}

.TasksView-module__gap-12___iVZn4 {
  gap: 12px !important;
}

.TasksView-module__gap-14___gyY7K {
  gap: 14px !important;
}

.TasksView-module__gap-16___eEQ6q {
  gap: 16px !important;
}

.TasksView-module__gap-18___Hz2lx {
  gap: 18px !important;
}

.TasksView-module__gap-20___XvZYG {
  gap: 20px !important;
}

.TasksView-module__gap-24___YnudV {
  gap: 24px !important;
}

.TasksView-module__gap-26___deOws {
  gap: 26px !important;
}

.TasksView-module__gap-30___pDBeG {
  gap: 30px !important;
}

.TasksView-module__gap-32___uxqd_ {
  gap: 32px !important;
}

.TasksView-module__gap-40___m2bSE {
  gap: 40px !important;
}

.TasksView-module__gap-50___LXiTM {
  gap: 50px !important;
}

.TasksView-module__flex-1___oGoLD {
  flex: 1;
}

.TasksView-module__flex-none___rtSFP {
  flex: none !important;
}

.TasksView-module__flex-column___SI4tb {
  display: flex;
  flex-direction: column !important;
}

.TasksView-module__flex-row___ftfjC {
  display: flex;
  flex-direction: row !important;
}

.TasksView-module__vertically-centered___F9LPq {
  display: flex;
  align-items: center !important;
}

.TasksView-module__horizontally-centered___psOR9 {
  display: flex;
  justify-content: center !important;
}

.TasksView-module__horizontally-end___IVS7U {
  display: flex;
  justify-content: end !important;
}

.TasksView-module__vertically-start___mBGU5 {
  display: flex;
  align-items: start !important;
}

.TasksView-module__space-between___lf1H9 {
  display: flex;
  justify-content: space-between !important;
}

.TasksView-module__flex-wrap___MIef5 {
  flex-wrap: wrap !important;
}

.TasksView-module__height-100___PRZZD {
  height: 100%;
}

.TasksView-module__width-50___IYysZ {
  width: 50% !important;
}

.TasksView-module__width-100___eBl5I {
  width: 100%;
}

.TasksView-module__cursor-pointer___hIiaM {
  cursor: pointer;
}

.TasksView-module__cursor-not-allowed___AKpKq {
  cursor: not-allowed !important;
}

.TasksView-module__absolute-centered___trpFR {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.TasksView-module__absolute___CKnXM {
  position: absolute;
}

.TasksView-module__relative___zdeNP {
  position: relative;
}

.TasksView-module__fixed___OlH11 {
  position: fixed;
}

.TasksView-module__visible___BtICM {
  opacity: 1;
}

.TasksView-module__invisible___kodmR {
  opacity: 0;
}

.TasksView-module__col-90___jX4GC {
  width: 90% !important;
}

.TasksView-module__col-auto___hj9xL {
  width: auto !important;
}

.TasksView-module__medical-tabs___PWs2v {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.TasksView-module__medical-table-new___nVJKa {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.TasksView-module__medical-table-new___nVJKa:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.TasksView-module__medical-table-new___nVJKa::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.TasksView-module__medical-table-new___nVJKa::-webkit-scrollbar-track {
  display: none;
}
.TasksView-module__medical-table-new___nVJKa.TasksView-module__no-pagination___jK8XN {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.TasksView-module__medical-table-new___nVJKa.TasksView-module__no-pagination___jK8XN:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.TasksView-module__medical-table-new___nVJKa.TasksView-module__no-pagination___jK8XN::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.TasksView-module__medical-table-new___nVJKa.TasksView-module__no-pagination___jK8XN::-webkit-scrollbar-track {
  display: none;
}

.TasksView-module__medical-table-empty____J6Xi {
  padding: 14px 40px !important;
}

.TasksView-module__icon-btn___v4NqX {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.TasksView-module__search-icon___MRE6R {
  width: 24px;
  height: 24px;
  align-self: center;
}

.TasksView-module__disable-select___yJ8Uk {
  user-select: none;
}

.TasksView-module__break-word____LNhu {
  word-break: break-word;
}

.TasksView-module__popup-clear-btn___AWGju {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.TasksView-module__scroll-m-b-20___j8Hla {
  scroll-margin-bottom: 20px;
}

.TasksView-module__scopeBar___jV255 {
  margin-bottom: 12px;
}

.TasksView-module__teamTabsBar___d3C6O {
  margin-bottom: 8px;
}

.TasksView-module__teamTabsGroup___K0S40 {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 0;
  border: 1px solid #ececf0;
  border-radius: 8px;
  background: #f5f5f5;
  overflow: hidden;
}

.TasksView-module__teamTabButton___QD6Pe {
  min-height: 30px;
  padding: 8px 16px;
  border: none;
  background: transparent;
  color: #a1a1aa;
  font-size: 12px;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  cursor: pointer;
  transition: background 120ms ease, box-shadow 120ms ease, color 120ms ease;
}

.TasksView-module__teamTabButton___QD6Pe:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: -2px;
}

.TasksView-module__teamTabActive___hkUk8 {
  background: #ffffff;
  color: #18181b;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.TasksView-module__teamTabIcon___q1qZg {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: currentColor;
  width: 14px;
  height: 14px;
}

.TasksView-module__teamTabCount___EhwRQ {
  font-family: "IBM Plex Mono", monospace;
  font-size: 11px;
  color: currentColor;
}

.TasksView-module__teamTabActive___hkUk8 .TasksView-module__teamTabCount___EhwRQ {
  font-weight: 600;
}

.TasksView-module__filters___Pl6i9 {
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  padding: 8px 14px;
  margin-bottom: 12px;
}

.TasksView-module__filterRow___OWOhf {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  flex: 1 1 auto;
  min-width: 0;
  flex-wrap: wrap;
}

.TasksView-module__filterRow___OWOhf + .TasksView-module__filterRow___OWOhf {
  margin-top: 0;
}

.TasksView-module__filterActions___hmoBE {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.TasksView-module__filterGroup___tVkDu {
  display: flex;
  gap: 1px;
  background: #f4f4f5;
  border-radius: 5px;
  padding: 2px;
}

@media (max-width: 900px) {
  .TasksView-module__teamTabsGroup___K0S40 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
.TasksView-module__filterButton___z3RW4 {
  padding: 3px 10px;
  font-size: 11px;
  font-weight: 500;
  border-radius: 3px;
  border: none;
  cursor: pointer;
  background: transparent;
  color: #71717a;
  box-shadow: none;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.TasksView-module__filterButton___z3RW4:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
}

.TasksView-module__filterActive___kCAD4 {
  background: #ffffff;
  color: #18181b;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.TasksView-module__filterCount___soaQE {
  font-family: "IBM Plex Mono", monospace;
  font-size: 10px;
  color: #a1a1aa;
  margin-left: 2px;
}

.TasksView-module__filterDivider___aCbrO {
  width: 1px;
  height: 20px;
  background: #e4e4e7;
}

.TasksView-module__filterActionButton___Q5yY1 {
  border: 1px solid #d4d4d8;
  border-radius: 4px;
  background: #ffffff;
  color: #52525b;
  padding: 5px 10px;
  font-size: 11px;
  line-height: 1;
  cursor: pointer;
  white-space: nowrap;
}

.TasksView-module__filterActionButton___Q5yY1:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
}

.TasksView-module__filterActionButton___Q5yY1:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.TasksView-module__layout___E70xN {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  align-items: start;
  padding-bottom: 80px;
}

.TasksView-module__layoutWithDetail____5oOj {
  grid-template-columns: minmax(0, 1fr) 440px;
}

.TasksView-module__listCard___IBvtO {
  background: #ffffff;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
}

.TasksView-module__summaryBar____xfBL {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 14px;
  border-bottom: 1px solid #e4e4e7;
  background: #fafafa;
}

.TasksView-module__summaryMeta___WbSGW {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.TasksView-module__summaryActions___EIsMY {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  flex-wrap: wrap;
}

.TasksView-module__summarySortMenu___leOXr {
  position: relative;
}

.TasksView-module__summarySortTrigger___Ensnw {
  border: none;
  background: transparent;
  color: #6b7280;
  font-size: 11px;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  padding: 0;
}

.TasksView-module__summarySortTrigger___Ensnw:hover {
  color: #111827;
}

.TasksView-module__summarySortTrigger___Ensnw:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
  border-radius: 4px;
}

.TasksView-module__summarySortChevron___tX8qG {
  color: currentColor;
  transition: transform 120ms ease;
}

.TasksView-module__summarySortChevronOpen___KO663 {
  transform: rotate(180deg);
}

.TasksView-module__summarySortDropdown___AiXHR {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  z-index: 20;
  min-width: 158px;
  overflow: hidden;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
  padding: 6px;
}

.TasksView-module__summarySortOption___X0B1M {
  width: 100%;
  border: none;
  background: transparent;
  color: #374151;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border-radius: 6px;
  cursor: pointer;
  text-align: left;
  font-size: 12px;
}

.TasksView-module__summarySortOption___X0B1M:hover {
  background: #f3f4f6;
  color: #111827;
}

.TasksView-module__summarySortOption___X0B1M:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: -2px;
}

.TasksView-module__summarySortCheck___rk9R7 {
  opacity: 0;
  color: #111827;
  flex-shrink: 0;
}

.TasksView-module__summarySortCheckVisible___PAdJV {
  opacity: 1;
}

.TasksView-module__summaryText___DOEKP {
  font-size: 11px;
  font-weight: 600;
  color: #52525b;
}

.TasksView-module__prioritySummary___IjJ4X {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
}

.TasksView-module__prioritySummaryItem___vz4LM {
  font-size: 11px;
  line-height: 1.2;
  white-space: nowrap;
}

.TasksView-module__prioritySummaryDivider___UM7VA {
  font-size: 11px;
  line-height: 1.2;
  color: #a1a1aa;
}

.TasksView-module__prioritySummaryCritical___T_uwl {
  color: #b91c1c;
  font-weight: 600;
}

.TasksView-module__prioritySummaryHigh___ZHJyG {
  color: #c2410c;
}

.TasksView-module__prioritySummaryMedium___eERUN {
  color: #ca8a04;
}

.TasksView-module__prioritySummaryLow___jbe2Q {
  color: #71717a;
}

.TasksView-module__summarySort___TA4W1 {
  border: none;
  background: transparent;
  font-size: 11px;
  color: #a1a1aa;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  font-family: "IBM Plex Mono", monospace;
}

@media (max-width: 720px) {
  .TasksView-module__summaryBar____xfBL {
    flex-direction: column;
  }
  .TasksView-module__summaryActions___EIsMY {
    width: 100%;
    justify-content: flex-start;
  }
}
.TasksView-module__emptyState___Bf_76 {
  padding: 40px;
  text-align: center;
  color: #a1a1aa;
  font-size: 13px;
}

.TasksView-module__loaderWrap___jTgQF {
  display: flex;
  justify-content: center;
  padding: 24px 0;
}

.TasksView-module__detailPanel___BUto3 {
  align-self: start;
  position: sticky;
  top: 16px;
  max-height: calc(100vh - var(--tabs-navigation) - var(--secondary-navigation) - var(--patient-details-footer) - 54px);
  overflow-y: auto;
  scrollbar-width: none;
  padding-bottom: 80px;
}

.TasksView-module__detailPanel___BUto3::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.TasksView-module__patientGroup___p_yAT {
  border-bottom: 1px solid #e4e4e7;
}

.TasksView-module__leadRowWrap___spCHY {
  display: flex;
  align-items: center;
  background: #ffffff;
}

.TasksView-module__leadRowWrap___spCHY > .TasksView-module__patientRow___Rxu1O {
  flex: 1;
  min-width: 0;
}

.TasksView-module__leadPatientActions___B4JB5 {
  flex-shrink: 0;
  margin-right: 14px;
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 6px;
}

.TasksView-module__leadPatientLink___atzpn {
  padding: 4px 10px;
  border: 1px solid #d4d4d8;
  border-radius: 6px;
  background: #ffffff;
  color: #3f3f46;
  font-size: 12px;
  line-height: 18px;
  white-space: nowrap;
  cursor: pointer;
}

.TasksView-module__leadPatientLink___atzpn:hover,
.TasksView-module__leadPatientLink___atzpn:focus-visible {
  border-color: #18181b;
  color: #18181b;
}

.TasksView-module__patientRow___Rxu1O {
  width: 100%;
  border: none;
  background: #ffffff;
  display: grid;
  grid-template-columns: 16px 3px minmax(0, 1fr) auto 72px;
  gap: 12px;
  align-items: center;
  padding: 14px;
  text-align: left;
  cursor: pointer;
}

.TasksView-module__queueGroupRow___tUBeO {
  width: 100%;
  border: none;
  background: #ffffff;
  display: grid;
  grid-template-columns: 16px minmax(0, 1fr) auto;
  gap: 12px;
  align-items: center;
  padding: 14px;
  text-align: left;
  cursor: pointer;
}

.TasksView-module__queueGroupRow___tUBeO:hover {
  background: #fafafa;
}

.TasksView-module__queueGroupRow___tUBeO:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: -2px;
}

.TasksView-module__queueGroupMain___cmfhT {
  min-width: 0;
}

.TasksView-module__patientRow___Rxu1O:hover {
  background: #fafafa;
}

.TasksView-module__patientRow___Rxu1O:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: -2px;
}

.TasksView-module__patientChevron___myqwT {
  color: #6b7280;
  flex-shrink: 0;
  transition: transform 150ms ease;
}

.TasksView-module__patientChevronCollapsed___QSTzZ {
  transform: rotate(-90deg);
}

.TasksView-module__patientMarker___nppFu {
  width: 3px;
  height: 36px;
  border-radius: 999px;
  background: #18181b;
}

.TasksView-module__patientMain___twevs {
  min-width: 0;
  display: grid;
  gap: 6px;
}

.TasksView-module__patientTopRow___H8pES {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.TasksView-module__patientName___eeScu {
  font-size: 14px;
  font-weight: 600;
  color: #18181b;
}

.TasksView-module__patientMetaMuted___aYjDY {
  font-size: 12px;
  color: #a1a1aa;
  white-space: nowrap;
}

.TasksView-module__patientMetaRow___icMxd {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.TasksView-module__patientMetaText___UIxRk {
  font-size: 12px;
  color: #71717a;
}

.TasksView-module__pathwayBadge___ECuUa {
  line-height: 16px;
}

.TasksView-module__patientPills___nA_kr {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  flex-wrap: wrap;
}

.TasksView-module__patientSummaryBadge___jdZFE {
  line-height: 18px;
}

.TasksView-module__summaryPillGroup___H3ywY {
  display: inline-flex;
  align-items: stretch;
}

.TasksView-module__summaryPill___b7hkk {
  border: 1px solid #d4d4d8;
  border-radius: 4px;
  padding: 3px 8px;
  font-size: 11px;
  line-height: 1;
  color: #18181b;
  background: #ffffff;
  white-space: nowrap;
}

.TasksView-module__summaryPillDark___lJAjz {
  background: #18181b;
  border-color: #18181b;
  color: #ffffff;
}

.TasksView-module__summaryPillGrouped___f9sG2 {
  border-radius: 4px 0 0 4px;
}

.TasksView-module__summaryPillGroupedTrailing___f0UQF {
  border-left: none;
  border-radius: 0 4px 4px 0;
}

.TasksView-module__patientDue___c1k0f {
  font-size: 12px;
  font-weight: 500;
  color: #18181b;
  text-align: right;
  white-space: nowrap;
  font-family: "IBM Plex Mono", monospace;
}

.TasksView-module__patientExpanded___EbZeQ {
  padding: 8px 10px 10px 38px;
  border-top: 1px solid #e4e4e7;
  background: #f4f4f5;
}

.TasksView-module__bucketSection___MrR_B + .TasksView-module__bucketSection___MrR_B {
  margin-top: 6px;
}

.TasksView-module__bucketHeader___EWQgO {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px 3px;
}

.TasksView-module__bucketIndex___l0Csv {
  min-width: 16px;
  height: 16px;
  border-radius: 4px;
  background: #ffffff;
  border: 1px solid #d4d4d8;
  color: #71717a;
  font-size: 10px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.TasksView-module__bucketIndexDark___mjav5 {
  background: #18181b;
  border-color: #18181b;
  color: #ffffff;
}

.TasksView-module__bucketLabel___nPVXa {
  font-size: 12px;
  font-weight: 700;
  color: #18181b;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  line-height: 1.3333;
}

.TasksView-module__bucketCount___lHhi0 {
  font-family: "IBM Plex Mono", monospace;
  font-size: 12px;
  font-weight: 600;
  color: #52525b;
}

.TasksView-module__bucketRows___2BTSP {
  border: 1px solid #e4e4e7;
  border-radius: 6px;
  overflow: hidden;
  background: #ffffff;
}

.TasksView-module__childSectionLabel___ApcBJ {
  padding: 10px 14px 6px 22px;
  font-size: 12px;
  font-weight: 600;
  color: #a1a1aa;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  background: #ffffff;
  line-height: 1.3333;
}

.TasksView-module__childGroupContainer___aX3A8 {
  border-top: 2px solid #d4d4d8;
  border-bottom: 2px solid #d4d4d8;
  box-shadow: inset 0 2px 4px -2px rgba(0, 0, 0, 0.06), inset 0 -2px 4px -2px rgba(0, 0, 0, 0.06);
}

.TasksView-module__loadMoreWrap___cK8iA {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 18px 14px 22px;
}

.TasksView-module__loadMoreButton___aZ_XE {
  border: none;
  background: transparent;
  color: #52525b;
  padding: 4px 0;
  font-size: 11px;
  font-weight: 500;
  line-height: 1;
  font-family: "IBM Plex Mono", monospace;
  cursor: pointer;
  transition: color 120ms ease, opacity 120ms ease;
}

.TasksView-module__loadMoreButton___aZ_XE:hover:not(:disabled) {
  color: #18181b;
}

.TasksView-module__loadMoreButton___aZ_XE:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
  border-radius: 4px;
}

.TasksView-module__loadMoreButton___aZ_XE:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.TasksView-module__listCard___IBvtO {
  container-type: inline-size;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/CareOrchestration/components/TasksView/TasksView.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,mBAAA;AA8pBF;;AA3pBA;EACE,kBAAA;AA8pBF;;AA3pBA;EACE,aAAA;EACA,gDAAA;EACA,MAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AA8pBF;;AA3pBA;EACE,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;EACA,0EACE;AA6pBJ;;AAxpBA;EACE,0BAAA;EACA,oBAAA;AA2pBF;;AAxpBA;EACE,mBAAA;EACA,cAAA;EACA,yCAAA;AA2pBF;;AAxpBA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AA2pBF;;AAxpBA;EACE,uCAAA;EACA,eAAA;EACA,mBAAA;AA2pBF;;AAxpBA;EACE,gBAAA;AA2pBF;;AAxpBA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;AA2pBF;;AAxpBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;AA2pBF;;AAxpBA;EACE,aAAA;AA2pBF;;AAxpBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;AA2pBF;;AAxpBA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;AA2pBF;;AAxpBA;EACE;IACE,gDAAA;EA2pBF;AACF;AAxpBA;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;AA0pBF;;AAvpBA;EACE,0BAAA;EACA,mBAAA;AA0pBF;;AAvpBA;EACE,mBAAA;EACA,cAAA;EACA,yCAAA;AA0pBF;;AAvpBA;EACE,uCAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AA0pBF;;AAvpBA;EACE,UAAA;EACA,YAAA;EACA,mBAAA;AA0pBF;;AAvpBA;EACE,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;AA0pBF;;AAvpBA;EACE,0BAAA;EACA,mBAAA;AA0pBF;;AAvpBA;EACE,mBAAA;EACA,YAAA;AA0pBF;;AAvpBA;EACE,aAAA;EACA,0BAAA;EACA,SAAA;EACA,kBAAA;EACA,oBAAA;AA0pBF;;AAvpBA;EACE,2CAAA;AA0pBF;;AAvpBA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;AA0pBF;;AAvpBA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;EACA,mBAAA;AA0pBF;;AAvpBA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AA0pBF;;AAvpBA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,QAAA;EACA,eAAA;AA0pBF;;AAvpBA;EACE,kBAAA;AA0pBF;;AAvpBA;EACE,YAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,UAAA;AA0pBF;;AAvpBA;EACE,cAAA;AA0pBF;;AAvpBA;EACE,0BAAA;EACA,mBAAA;EACA,kBAAA;AA0pBF;;AAvpBA;EACE,mBAAA;EACA,gCAAA;AA0pBF;;AAvpBA;EACE,yBAAA;AA0pBF;;AAvpBA;EACE,kBAAA;EACA,qBAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kFACE;EAEF,YAAA;AAwpBF;;AArpBA;EACE,WAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAwpBF;;AArpBA;EACE,mBAAA;EACA,cAAA;AAwpBF;;AArpBA;EACE,0BAAA;EACA,oBAAA;AAwpBF;;AArpBA;EACE,UAAA;EACA,cAAA;EACA,cAAA;AAwpBF;;AArpBA;EACE,UAAA;AAwpBF;;AArpBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAwpBF;;AArpBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AAwpBF;;AArpBA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AAwpBF;;AArpBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAwpBF;;AArpBA;EACE,cAAA;EACA,gBAAA;AAwpBF;;AArpBA;EACE,cAAA;AAwpBF;;AArpBA;EACE,cAAA;AAwpBF;;AArpBA;EACE,cAAA;AAwpBF;;AArpBA;EACE,YAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,uCAAA;AAwpBF;;AArpBA;EACE;IACE,sBAAA;EAwpBF;EArpBA;IACE,WAAA;IACA,2BAAA;EAupBF;AACF;AAppBA;EACE,aAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AAspBF;;AAnpBA;EACE,aAAA;EACA,uBAAA;EACA,eAAA;AAspBF;;AAnpBA;EACE,iBAAA;EACA,gBAAA;EACA,SAAA;EACA,qHAAA;EAIA,gBAAA;EACA,qBAAA;EACA,oBAAA;AAmpBF;;AAhpBA;EACE,QAAA;EACA,SAAA;AAmpBF;;AAhpBA;EACE,gCAAA;AAmpBF;;AAhpBA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AAmpBF;;AAhpBA;EACE,OAAA;EACA,YAAA;AAmpBF;;AAhpBA;EACE,cAAA;EACA,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,yBAAA;EACA,QAAA;AAmpBF;;AAhpBA;EACE,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;AAmpBF;;AAhpBA;;EAEE,qBAAA;EACA,cAAA;AAmpBF;;AAhpBA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,wDAAA;EACA,SAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;AAmpBF;;AAhpBA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,+CAAA;EACA,SAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;AAmpBF;;AAhpBA;EACE,mBAAA;AAmpBF;;AAhpBA;EACE,0BAAA;EACA,oBAAA;AAmpBF;;AAhpBA;EACE,YAAA;AAmpBF;;AAhpBA;EACE,mBAAA;AAmpBF;;AAhpBA;EACE,0BAAA;EACA,oBAAA;AAmpBF;;AAhpBA;EACE,cAAA;EACA,cAAA;EACA,gCAAA;AAmpBF;;AAhpBA;EACE,yBAAA;AAmpBF;;AAhpBA;EACE,UAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;AAmpBF;;AAhpBA;EACE,YAAA;EACA,aAAA;EACA,QAAA;AAmpBF;;AAhpBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;AAmpBF;;AAhpBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAmpBF;;AAhpBA;EACE,eAAA;EACA,cAAA;EACA,mBAAA;AAmpBF;;AAhpBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AAmpBF;;AAhpBA;EACE,eAAA;EACA,cAAA;AAmpBF;;AAhpBA;EACE,iBAAA;AAmpBF;;AAhpBA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,QAAA;EACA,eAAA;AAmpBF;;AAhpBA;EACE,iBAAA;AAmpBF;;AAhpBA;EACE,oBAAA;EACA,oBAAA;AAmpBF;;AAhpBA;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;AAmpBF;;AAhpBA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AAmpBF;;AAhpBA;EACE,0BAAA;AAmpBF;;AAhpBA;EACE,iBAAA;EACA,0BAAA;AAmpBF;;AAhpBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,uCAAA;AAmpBF;;AAhpBA;EACE,2BAAA;EACA,6BAAA;EACA,mBAAA;AAmpBF;;AAhpBA;EACE,eAAA;AAmpBF;;AAhpBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,oBAAA;AAmpBF;;AAhpBA;EACE,eAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AAmpBF;;AAhpBA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AAmpBF;;AAhpBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;AAmpBF;;AAhpBA;EACE,uCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAmpBF;;AAhpBA;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAmpBF;;AAhpBA;EACE,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;AAmpBF;;AAhpBA;EACE,6BAAA;EACA,gCAAA;EACA,+FACE;AAkpBJ;;AA9oBA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;AAipBF;;AA9oBA;EACE,YAAA;EACA,uBAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,uCAAA;EACA,eAAA;EACA,gDACE;AAgpBJ;;AA5oBA;EACE,cAAA;AA+oBF;;AA5oBA;EACE,0BAAA;EACA,mBAAA;EACA,kBAAA;AA+oBF;;AA5oBA;EACE,mBAAA;EACA,YAAA;AA+oBF;;AA5oBA;EACE,2BAAA;AA+oBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.scopeBar {\n  margin-bottom: 12px;\n}\n\n.teamTabsBar {\n  margin-bottom: 8px;\n}\n\n.teamTabsGroup {\n  display: grid;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  gap: 0;\n  border: 1px solid #ececf0;\n  border-radius: 8px;\n  background: #f5f5f5;\n  overflow: hidden;\n}\n\n.teamTabButton {\n  min-height: 30px;\n  padding: 8px 16px;\n  border: none;\n  background: transparent;\n  color: #a1a1aa;\n  font-size: 12px;\n  font-weight: 500;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  cursor: pointer;\n  transition:\n    background 120ms ease,\n    box-shadow 120ms ease,\n    color 120ms ease;\n}\n\n.teamTabButton:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: -2px;\n}\n\n.teamTabActive {\n  background: #ffffff;\n  color: #18181b;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.teamTabIcon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: currentColor;\n  width: 14px;\n  height: 14px;\n}\n\n.teamTabCount {\n  font-family: 'IBM Plex Mono', monospace;\n  font-size: 11px;\n  color: currentColor;\n}\n\n.teamTabActive .teamTabCount {\n  font-weight: 600;\n}\n\n.filters {\n  background: #ffffff;\n  border: 1px solid #e4e4e7;\n  border-radius: 8px;\n  padding: 8px 14px;\n  margin-bottom: 12px;\n}\n\n.filterRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n  flex: 1 1 auto;\n  min-width: 0;\n  flex-wrap: wrap;\n}\n\n.filterRow + .filterRow {\n  margin-top: 0;\n}\n\n.filterActions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-left: auto;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n}\n\n.filterGroup {\n  display: flex;\n  gap: 1px;\n  background: #f4f4f5;\n  border-radius: 5px;\n  padding: 2px;\n}\n\n@media (max-width: 900px) {\n  .teamTabsGroup {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n.filterButton {\n  padding: 3px 10px;\n  font-size: 11px;\n  font-weight: 500;\n  border-radius: 3px;\n  border: none;\n  cursor: pointer;\n  background: transparent;\n  color: #71717a;\n  box-shadow: none;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.filterButton:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 2px;\n}\n\n.filterActive {\n  background: #ffffff;\n  color: #18181b;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.filterCount {\n  font-family: 'IBM Plex Mono', monospace;\n  font-size: 10px;\n  color: #a1a1aa;\n  margin-left: 2px;\n}\n\n.filterDivider {\n  width: 1px;\n  height: 20px;\n  background: #e4e4e7;\n}\n\n.filterActionButton {\n  border: 1px solid #d4d4d8;\n  border-radius: 4px;\n  background: #ffffff;\n  color: #52525b;\n  padding: 5px 10px;\n  font-size: 11px;\n  line-height: 1;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.filterActionButton:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 2px;\n}\n\n.filterActionButton:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.layout {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 16px;\n  align-items: start;\n  padding-bottom: 80px;\n}\n\n.layoutWithDetail {\n  grid-template-columns: minmax(0, 1fr) 440px;\n}\n\n.listCard {\n  background: #ffffff;\n  border: 1px solid #e4e4e7;\n  border-radius: 8px;\n}\n\n.summaryBar {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 10px 14px;\n  border-bottom: 1px solid #e4e4e7;\n  background: #fafafa;\n}\n\n.summaryMeta {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n}\n\n.summaryActions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.summarySortMenu {\n  position: relative;\n}\n\n.summarySortTrigger {\n  border: none;\n  background: transparent;\n  color: #6b7280;\n  font-size: 11px;\n  line-height: 1;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  cursor: pointer;\n  padding: 0;\n}\n\n.summarySortTrigger:hover {\n  color: #111827;\n}\n\n.summarySortTrigger:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 2px;\n  border-radius: 4px;\n}\n\n.summarySortChevron {\n  color: currentColor;\n  transition: transform 120ms ease;\n}\n\n.summarySortChevronOpen {\n  transform: rotate(180deg);\n}\n\n.summarySortDropdown {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  z-index: 20;\n  min-width: 158px;\n  overflow: hidden;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  background: #ffffff;\n  box-shadow:\n    0 10px 15px -3px rgba(0, 0, 0, 0.1),\n    0 4px 6px -4px rgba(0, 0, 0, 0.1);\n  padding: 6px;\n}\n\n.summarySortOption {\n  width: 100%;\n  border: none;\n  background: transparent;\n  color: #374151;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 10px;\n  border-radius: 6px;\n  cursor: pointer;\n  text-align: left;\n  font-size: 12px;\n}\n\n.summarySortOption:hover {\n  background: #f3f4f6;\n  color: #111827;\n}\n\n.summarySortOption:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: -2px;\n}\n\n.summarySortCheck {\n  opacity: 0;\n  color: #111827;\n  flex-shrink: 0;\n}\n\n.summarySortCheckVisible {\n  opacity: 1;\n}\n\n.summaryText {\n  font-size: 11px;\n  font-weight: 600;\n  color: #52525b;\n}\n\n.prioritySummary {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex-wrap: wrap;\n}\n\n.prioritySummaryItem {\n  font-size: 11px;\n  line-height: 1.2;\n  white-space: nowrap;\n}\n\n.prioritySummaryDivider {\n  font-size: 11px;\n  line-height: 1.2;\n  color: #a1a1aa;\n}\n\n.prioritySummaryCritical {\n  color: #b91c1c;\n  font-weight: 600;\n}\n\n.prioritySummaryHigh {\n  color: #c2410c;\n}\n\n.prioritySummaryMedium {\n  color: #ca8a04;\n}\n\n.prioritySummaryLow {\n  color: #71717a;\n}\n\n.summarySort {\n  border: none;\n  background: transparent;\n  font-size: 11px;\n  color: #a1a1aa;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  cursor: pointer;\n  font-family: 'IBM Plex Mono', monospace;\n}\n\n@media (max-width: 720px) {\n  .summaryBar {\n    flex-direction: column;\n  }\n\n  .summaryActions {\n    width: 100%;\n    justify-content: flex-start;\n  }\n}\n\n.emptyState {\n  padding: 40px;\n  text-align: center;\n  color: #a1a1aa;\n  font-size: 13px;\n}\n\n.loaderWrap {\n  display: flex;\n  justify-content: center;\n  padding: 24px 0;\n}\n\n.detailPanel {\n  align-self: start;\n  position: sticky;\n  top: 16px;\n  max-height: calc(\n    100vh - var(--tabs-navigation) - var(--secondary-navigation) - var(--patient-details-footer) -\n      54px\n  );\n  overflow-y: auto;\n  scrollbar-width: none;\n  padding-bottom: 80px;\n}\n\n.detailPanel::-webkit-scrollbar {\n  width: 0;\n  height: 0;\n}\n\n.patientGroup {\n  border-bottom: 1px solid #e4e4e7;\n}\n\n.leadRowWrap {\n  display: flex;\n  align-items: center;\n  background: #ffffff;\n}\n\n.leadRowWrap > .patientRow {\n  flex: 1;\n  min-width: 0;\n}\n\n.leadPatientActions {\n  flex-shrink: 0;\n  margin-right: 14px;\n  display: inline-flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: 6px;\n}\n\n.leadPatientLink {\n  padding: 4px 10px;\n  border: 1px solid #d4d4d8;\n  border-radius: 6px;\n  background: #ffffff;\n  color: #3f3f46;\n  font-size: 12px;\n  line-height: 18px;\n  white-space: nowrap;\n  cursor: pointer;\n}\n\n.leadPatientLink:hover,\n.leadPatientLink:focus-visible {\n  border-color: #18181b;\n  color: #18181b;\n}\n\n.patientRow {\n  width: 100%;\n  border: none;\n  background: #ffffff;\n  display: grid;\n  grid-template-columns: 16px 3px minmax(0, 1fr) auto 72px;\n  gap: 12px;\n  align-items: center;\n  padding: 14px;\n  text-align: left;\n  cursor: pointer;\n}\n\n.queueGroupRow {\n  width: 100%;\n  border: none;\n  background: #ffffff;\n  display: grid;\n  grid-template-columns: 16px minmax(0, 1fr) auto;\n  gap: 12px;\n  align-items: center;\n  padding: 14px;\n  text-align: left;\n  cursor: pointer;\n}\n\n.queueGroupRow:hover {\n  background: #fafafa;\n}\n\n.queueGroupRow:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: -2px;\n}\n\n.queueGroupMain {\n  min-width: 0;\n}\n\n.patientRow:hover {\n  background: #fafafa;\n}\n\n.patientRow:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: -2px;\n}\n\n.patientChevron {\n  color: #6b7280;\n  flex-shrink: 0;\n  transition: transform 150ms ease;\n}\n\n.patientChevronCollapsed {\n  transform: rotate(-90deg);\n}\n\n.patientMarker {\n  width: 3px;\n  height: 36px;\n  border-radius: 999px;\n  background: #18181b;\n}\n\n.patientMain {\n  min-width: 0;\n  display: grid;\n  gap: 6px;\n}\n\n.patientTopRow {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n\n.patientName {\n  font-size: 14px;\n  font-weight: 600;\n  color: #18181b;\n}\n\n.patientMetaMuted {\n  font-size: 12px;\n  color: #a1a1aa;\n  white-space: nowrap;\n}\n\n.patientMetaRow {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.patientMetaText {\n  font-size: 12px;\n  color: #71717a;\n}\n\n.pathwayBadge {\n  line-height: 16px;\n}\n\n.patientPills {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n\n.patientSummaryBadge {\n  line-height: 18px;\n}\n\n.summaryPillGroup {\n  display: inline-flex;\n  align-items: stretch;\n}\n\n.summaryPill {\n  border: 1px solid #d4d4d8;\n  border-radius: 4px;\n  padding: 3px 8px;\n  font-size: 11px;\n  line-height: 1;\n  color: #18181b;\n  background: #ffffff;\n  white-space: nowrap;\n}\n\n.summaryPillDark {\n  background: #18181b;\n  border-color: #18181b;\n  color: #ffffff;\n}\n\n.summaryPillGrouped {\n  border-radius: 4px 0 0 4px;\n}\n\n.summaryPillGroupedTrailing {\n  border-left: none;\n  border-radius: 0 4px 4px 0;\n}\n\n.patientDue {\n  font-size: 12px;\n  font-weight: 500;\n  color: #18181b;\n  text-align: right;\n  white-space: nowrap;\n  font-family: 'IBM Plex Mono', monospace;\n}\n\n.patientExpanded {\n  padding: 8px 10px 10px 38px;\n  border-top: 1px solid #e4e4e7;\n  background: #f4f4f5;\n}\n\n.bucketSection + .bucketSection {\n  margin-top: 6px;\n}\n\n.bucketHeader {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 8px 3px;\n}\n\n.bucketIndex {\n  min-width: 16px;\n  height: 16px;\n  border-radius: 4px;\n  background: #ffffff;\n  border: 1px solid #d4d4d8;\n  color: #71717a;\n  font-size: 10px;\n  font-weight: 600;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.bucketIndexDark {\n  background: #18181b;\n  border-color: #18181b;\n  color: #ffffff;\n}\n\n.bucketLabel {\n  font-size: 12px;\n  font-weight: 700;\n  color: #18181b;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  line-height: 1.3333;\n}\n\n.bucketCount {\n  font-family: 'IBM Plex Mono', monospace;\n  font-size: 12px;\n  font-weight: 600;\n  color: #52525b;\n}\n\n.bucketRows {\n  border: 1px solid #e4e4e7;\n  border-radius: 6px;\n  overflow: hidden;\n  background: #ffffff;\n}\n\n.childSectionLabel {\n  padding: 10px 14px 6px 22px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #a1a1aa;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  background: #ffffff;\n  line-height: 1.3333;\n}\n\n.childGroupContainer {\n  border-top: 2px solid #d4d4d8;\n  border-bottom: 2px solid #d4d4d8;\n  box-shadow:\n    inset 0 2px 4px -2px rgba(0, 0, 0, 0.06),\n    inset 0 -2px 4px -2px rgba(0, 0, 0, 0.06);\n}\n\n.loadMoreWrap {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 18px 14px 22px;\n}\n\n.loadMoreButton {\n  border: none;\n  background: transparent;\n  color: #52525b;\n  padding: 4px 0;\n  font-size: 11px;\n  font-weight: 500;\n  line-height: 1;\n  font-family: 'IBM Plex Mono', monospace;\n  cursor: pointer;\n  transition:\n    color 120ms ease,\n    opacity 120ms ease;\n}\n\n.loadMoreButton:hover:not(:disabled) {\n  color: #18181b;\n}\n\n.loadMoreButton:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 2px;\n  border-radius: 4px;\n}\n\n.loadMoreButton:disabled {\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.listCard {\n  container-type: inline-size;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `TasksView-module__font-s-10___Nbzyq`,
	"fontS12": `TasksView-module__font-s-12___o07lQ`,
	"fontS13": `TasksView-module__font-s-13___N9UwD`,
	"fontS14": `TasksView-module__font-s-14___bURso`,
	"fontS15": `TasksView-module__font-s-15___YgjGn`,
	"fontS16": `TasksView-module__font-s-16___YTVv0`,
	"fontS18": `TasksView-module__font-s-18___tb6XM`,
	"fontS20": `TasksView-module__font-s-20___YQEZP`,
	"fontS22": `TasksView-module__font-s-22___JXI4Z`,
	"fontS28": `TasksView-module__font-s-28___z8baj`,
	"fontW400": `TasksView-module__font-w-400___wRfUh`,
	"fontW500": `TasksView-module__font-w-500___rUKBG`,
	"fontW600": `TasksView-module__font-w-600___O84ZF`,
	"fontW700": `TasksView-module__font-w-700___LFzI7`,
	"p5": `TasksView-module__p-5___rXO3x`,
	"p12": `TasksView-module__p-12___BOCj2`,
	"p16": `TasksView-module__p-16___y4nfO`,
	"p30": `TasksView-module__p-30___Cd5oP`,
	"pB0": `TasksView-module__p-b-0___Qdq4u`,
	"pB5": `TasksView-module__p-b-5___ILV_Z`,
	"pB10": `TasksView-module__p-b-10___q7yu8`,
	"pB12": `TasksView-module__p-b-12___kOaoA`,
	"pB16": `TasksView-module__p-b-16___WClaZ`,
	"pB18": `TasksView-module__p-b-18___JaM5s`,
	"pB20": `TasksView-module__p-b-20___Dvsvf`,
	"pB25": `TasksView-module__p-b-25___WrFf_`,
	"pB30": `TasksView-module__p-b-30___RvdKU`,
	"pB50": `TasksView-module__p-b-50____AVts`,
	"pT0": `TasksView-module__p-t-0___vnsVW`,
	"pT12": `TasksView-module__p-t-12___eCFU7`,
	"pT16": `TasksView-module__p-t-16___BWyZX`,
	"pT18": `TasksView-module__p-t-18___VljHN`,
	"pT20": `TasksView-module__p-t-20___PPxQG`,
	"pT30": `TasksView-module__p-t-30___tZhWr`,
	"pT40": `TasksView-module__p-t-40___NnV0m`,
	"pT50": `TasksView-module__p-t-50___PRiHf`,
	"pL20": `TasksView-module__p-l-20___WZI2g`,
	"pL30": `TasksView-module__p-l-30___XhYqO`,
	"pL40": `TasksView-module__p-l-40___uE1Nw`,
	"pR16": `TasksView-module__p-r-16___Ll1Ba`,
	"pR20": `TasksView-module__p-r-20___AJaP4`,
	"pR30": `TasksView-module__p-r-30___v9Kjn`,
	"pR50": `TasksView-module__p-r-50___KYYos`,
	"pR60": `TasksView-module__p-r-60___W1Nn6`,
	"mB1": `TasksView-module__m-b-1___OQqye`,
	"mB2": `TasksView-module__m-b-2___NBCqA`,
	"mB6": `TasksView-module__m-b-6___lc6Ho`,
	"mB8": `TasksView-module__m-b-8___OougC`,
	"mB10": `TasksView-module__m-b-10___W90qg`,
	"mB14": `TasksView-module__m-b-14___H8aym`,
	"mB16": `TasksView-module__m-b-16____Dygj`,
	"mB20": `TasksView-module__m-b-20___uVJRn`,
	"mB22": `TasksView-module__m-b-22___Usixw`,
	"mB24": `TasksView-module__m-b-24___VbVGR`,
	"mB30": `TasksView-module__m-b-30___En97Q`,
	"mB32": `TasksView-module__m-b-32___cnJWX`,
	"mB40": `TasksView-module__m-b-40___TyPsN`,
	"mT2": `TasksView-module__m-t-2___Osm8j`,
	"mT3": `TasksView-module__m-t-3___K6cCK`,
	"mT4": `TasksView-module__m-t-4___W2eZs`,
	"mT5": `TasksView-module__m-t-5___KaUdW`,
	"mT8": `TasksView-module__m-t-8___jXqhe`,
	"mT10": `TasksView-module__m-t-10___Dt3yL`,
	"mT15": `TasksView-module__m-t-15___jGV1h`,
	"mT16": `TasksView-module__m-t-16___uZPMP`,
	"mT20": `TasksView-module__m-t-20___d57bl`,
	"mT22": `TasksView-module__m-t-22___mtbca`,
	"mT30": `TasksView-module__m-t-30___vB7A3`,
	"mT32": `TasksView-module__m-t-32___tfo8o`,
	"mLAuto": `TasksView-module__m-l-auto___MRf2y`,
	"mL4": `TasksView-module__m-l-4____3xdN`,
	"mL5": `TasksView-module__m-l-5___esotw`,
	"mL6": `TasksView-module__m-l-6___VYq79`,
	"mL8": `TasksView-module__m-l-8___A6J_D`,
	"mL10": `TasksView-module__m-l-10___sEZsC`,
	"mL16": `TasksView-module__m-l-16___ROs8c`,
	"mL20": `TasksView-module__m-l-20___wjSfK`,
	"mL24": `TasksView-module__m-l-24___PPLdL`,
	"mL30": `TasksView-module__m-l-30___Eokx6`,
	"mL35": `TasksView-module__m-l-35___ZcvH7`,
	"mL40": `TasksView-module__m-l-40___iqRTw`,
	"mR8": `TasksView-module__m-r-8___Y_fhq`,
	"mR10": `TasksView-module__m-r-10___tBwsX`,
	"mR16": `TasksView-module__m-r-16___xQv53`,
	"mR20": `TasksView-module__m-r-20____z6UP`,
	"mR24": `TasksView-module__m-r-24___wbTZg`,
	"mR30": `TasksView-module__m-r-30___kcORT`,
	"mR40": `TasksView-module__m-r-40___BQKIz`,
	"borderR3": `TasksView-module__border-r-3___LahwX`,
	"borderR4": `TasksView-module__border-r-4___Oq3db`,
	"borderR6": `TasksView-module__border-r-6___o8yPN`,
	"borderR10": `TasksView-module__border-r-10___eIOxE`,
	"borderR12": `TasksView-module__border-r-12___x932X`,
	"borderR16": `TasksView-module__border-r-16___DuWEA`,
	"borderR50": `TasksView-module__border-r-50___Qx6Z4`,
	"primaryBorder": `TasksView-module__primary-border___niNYr`,
	"primaryBorderB": `TasksView-module__primary-border-b___nfZ0B`,
	"primaryBorderT": `TasksView-module__primary-border-t___JSVcm`,
	"primaryBorderL": `TasksView-module__primary-border-l___i08aJ`,
	"primaryBorderR": `TasksView-module__primary-border-r___bkMFY`,
	"secondaryBorder": `TasksView-module__secondary-border____EXKg`,
	"secondaryBorderB": `TasksView-module__secondary-border-b___nlW_F`,
	"secondaryBorderT": `TasksView-module__secondary-border-t___FHWEg`,
	"secondaryBorderL": `TasksView-module__secondary-border-l___DBEKi`,
	"secondaryBorderR": `TasksView-module__secondary-border-r___uflmS`,
	"gap0": `TasksView-module__gap-0___kFaqY`,
	"gap2": `TasksView-module__gap-2___udmBt`,
	"gap4": `TasksView-module__gap-4___IydaM`,
	"gap5": `TasksView-module__gap-5___MDKR0`,
	"gap6": `TasksView-module__gap-6___CzZn4`,
	"gap8": `TasksView-module__gap-8___y_YEk`,
	"gap10": `TasksView-module__gap-10___JFR_C`,
	"gap12": `TasksView-module__gap-12___iVZn4`,
	"gap14": `TasksView-module__gap-14___gyY7K`,
	"gap16": `TasksView-module__gap-16___eEQ6q`,
	"gap18": `TasksView-module__gap-18___Hz2lx`,
	"gap20": `TasksView-module__gap-20___XvZYG`,
	"gap24": `TasksView-module__gap-24___YnudV`,
	"gap26": `TasksView-module__gap-26___deOws`,
	"gap30": `TasksView-module__gap-30___pDBeG`,
	"gap32": `TasksView-module__gap-32___uxqd_`,
	"gap40": `TasksView-module__gap-40___m2bSE`,
	"gap50": `TasksView-module__gap-50___LXiTM`,
	"flex1": `TasksView-module__flex-1___oGoLD`,
	"flexNone": `TasksView-module__flex-none___rtSFP`,
	"flexColumn": `TasksView-module__flex-column___SI4tb`,
	"flexRow": `TasksView-module__flex-row___ftfjC`,
	"verticallyCentered": `TasksView-module__vertically-centered___F9LPq`,
	"horizontallyCentered": `TasksView-module__horizontally-centered___psOR9`,
	"horizontallyEnd": `TasksView-module__horizontally-end___IVS7U`,
	"verticallyStart": `TasksView-module__vertically-start___mBGU5`,
	"spaceBetween": `TasksView-module__space-between___lf1H9`,
	"flexWrap": `TasksView-module__flex-wrap___MIef5`,
	"height100": `TasksView-module__height-100___PRZZD`,
	"width50": `TasksView-module__width-50___IYysZ`,
	"width100": `TasksView-module__width-100___eBl5I`,
	"cursorPointer": `TasksView-module__cursor-pointer___hIiaM`,
	"cursorNotAllowed": `TasksView-module__cursor-not-allowed___AKpKq`,
	"absoluteCentered": `TasksView-module__absolute-centered___trpFR`,
	"absolute": `TasksView-module__absolute___CKnXM`,
	"relative": `TasksView-module__relative___zdeNP`,
	"fixed": `TasksView-module__fixed___OlH11`,
	"visible": `TasksView-module__visible___BtICM`,
	"invisible": `TasksView-module__invisible___kodmR`,
	"col90": `TasksView-module__col-90___jX4GC`,
	"colAuto": `TasksView-module__col-auto___hj9xL`,
	"medicalTabs": `TasksView-module__medical-tabs___PWs2v`,
	"medicalTableNew": `TasksView-module__medical-table-new___nVJKa`,
	"noPagination": `TasksView-module__no-pagination___jK8XN`,
	"medicalTableEmpty": `TasksView-module__medical-table-empty____J6Xi`,
	"iconBtn": `TasksView-module__icon-btn___v4NqX`,
	"searchIcon": `TasksView-module__search-icon___MRE6R`,
	"disableSelect": `TasksView-module__disable-select___yJ8Uk`,
	"breakWord": `TasksView-module__break-word____LNhu`,
	"popupClearBtn": `TasksView-module__popup-clear-btn___AWGju`,
	"scrollMB20": `TasksView-module__scroll-m-b-20___j8Hla`,
	"scopeBar": `TasksView-module__scopeBar___jV255`,
	"teamTabsBar": `TasksView-module__teamTabsBar___d3C6O`,
	"teamTabsGroup": `TasksView-module__teamTabsGroup___K0S40`,
	"teamTabButton": `TasksView-module__teamTabButton___QD6Pe`,
	"teamTabActive": `TasksView-module__teamTabActive___hkUk8`,
	"teamTabIcon": `TasksView-module__teamTabIcon___q1qZg`,
	"teamTabCount": `TasksView-module__teamTabCount___EhwRQ`,
	"filters": `TasksView-module__filters___Pl6i9`,
	"filterRow": `TasksView-module__filterRow___OWOhf`,
	"filterActions": `TasksView-module__filterActions___hmoBE`,
	"filterGroup": `TasksView-module__filterGroup___tVkDu`,
	"filterButton": `TasksView-module__filterButton___z3RW4`,
	"filterActive": `TasksView-module__filterActive___kCAD4`,
	"filterCount": `TasksView-module__filterCount___soaQE`,
	"filterDivider": `TasksView-module__filterDivider___aCbrO`,
	"filterActionButton": `TasksView-module__filterActionButton___Q5yY1`,
	"layout": `TasksView-module__layout___E70xN`,
	"layoutWithDetail": `TasksView-module__layoutWithDetail____5oOj`,
	"listCard": `TasksView-module__listCard___IBvtO`,
	"summaryBar": `TasksView-module__summaryBar____xfBL`,
	"summaryMeta": `TasksView-module__summaryMeta___WbSGW`,
	"summaryActions": `TasksView-module__summaryActions___EIsMY`,
	"summarySortMenu": `TasksView-module__summarySortMenu___leOXr`,
	"summarySortTrigger": `TasksView-module__summarySortTrigger___Ensnw`,
	"summarySortChevron": `TasksView-module__summarySortChevron___tX8qG`,
	"summarySortChevronOpen": `TasksView-module__summarySortChevronOpen___KO663`,
	"summarySortDropdown": `TasksView-module__summarySortDropdown___AiXHR`,
	"summarySortOption": `TasksView-module__summarySortOption___X0B1M`,
	"summarySortCheck": `TasksView-module__summarySortCheck___rk9R7`,
	"summarySortCheckVisible": `TasksView-module__summarySortCheckVisible___PAdJV`,
	"summaryText": `TasksView-module__summaryText___DOEKP`,
	"prioritySummary": `TasksView-module__prioritySummary___IjJ4X`,
	"prioritySummaryItem": `TasksView-module__prioritySummaryItem___vz4LM`,
	"prioritySummaryDivider": `TasksView-module__prioritySummaryDivider___UM7VA`,
	"prioritySummaryCritical": `TasksView-module__prioritySummaryCritical___T_uwl`,
	"prioritySummaryHigh": `TasksView-module__prioritySummaryHigh___ZHJyG`,
	"prioritySummaryMedium": `TasksView-module__prioritySummaryMedium___eERUN`,
	"prioritySummaryLow": `TasksView-module__prioritySummaryLow___jbe2Q`,
	"summarySort": `TasksView-module__summarySort___TA4W1`,
	"emptyState": `TasksView-module__emptyState___Bf_76`,
	"loaderWrap": `TasksView-module__loaderWrap___jTgQF`,
	"detailPanel": `TasksView-module__detailPanel___BUto3`,
	"patientGroup": `TasksView-module__patientGroup___p_yAT`,
	"leadRowWrap": `TasksView-module__leadRowWrap___spCHY`,
	"patientRow": `TasksView-module__patientRow___Rxu1O`,
	"leadPatientActions": `TasksView-module__leadPatientActions___B4JB5`,
	"leadPatientLink": `TasksView-module__leadPatientLink___atzpn`,
	"queueGroupRow": `TasksView-module__queueGroupRow___tUBeO`,
	"queueGroupMain": `TasksView-module__queueGroupMain___cmfhT`,
	"patientChevron": `TasksView-module__patientChevron___myqwT`,
	"patientChevronCollapsed": `TasksView-module__patientChevronCollapsed___QSTzZ`,
	"patientMarker": `TasksView-module__patientMarker___nppFu`,
	"patientMain": `TasksView-module__patientMain___twevs`,
	"patientTopRow": `TasksView-module__patientTopRow___H8pES`,
	"patientName": `TasksView-module__patientName___eeScu`,
	"patientMetaMuted": `TasksView-module__patientMetaMuted___aYjDY`,
	"patientMetaRow": `TasksView-module__patientMetaRow___icMxd`,
	"patientMetaText": `TasksView-module__patientMetaText___UIxRk`,
	"pathwayBadge": `TasksView-module__pathwayBadge___ECuUa`,
	"patientPills": `TasksView-module__patientPills___nA_kr`,
	"patientSummaryBadge": `TasksView-module__patientSummaryBadge___jdZFE`,
	"summaryPillGroup": `TasksView-module__summaryPillGroup___H3ywY`,
	"summaryPill": `TasksView-module__summaryPill___b7hkk`,
	"summaryPillDark": `TasksView-module__summaryPillDark___lJAjz`,
	"summaryPillGrouped": `TasksView-module__summaryPillGrouped___f9sG2`,
	"summaryPillGroupedTrailing": `TasksView-module__summaryPillGroupedTrailing___f0UQF`,
	"patientDue": `TasksView-module__patientDue___c1k0f`,
	"patientExpanded": `TasksView-module__patientExpanded___EbZeQ`,
	"bucketSection": `TasksView-module__bucketSection___MrR_B`,
	"bucketHeader": `TasksView-module__bucketHeader___EWQgO`,
	"bucketIndex": `TasksView-module__bucketIndex___l0Csv`,
	"bucketIndexDark": `TasksView-module__bucketIndexDark___mjav5`,
	"bucketLabel": `TasksView-module__bucketLabel___nPVXa`,
	"bucketCount": `TasksView-module__bucketCount___lHhi0`,
	"bucketRows": `TasksView-module__bucketRows___2BTSP`,
	"childSectionLabel": `TasksView-module__childSectionLabel___ApcBJ`,
	"childGroupContainer": `TasksView-module__childGroupContainer___aX3A8`,
	"loadMoreWrap": `TasksView-module__loadMoreWrap___cK8iA`,
	"loadMoreButton": `TasksView-module__loadMoreButton___aZ_XE`
};
module.exports = ___CSS_LOADER_EXPORT___;
